module.exports = __webpack_public_path__ + "img/feat_xplatform.50050de4.png";